module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/pets//snow_4_2.png?v=1ad95450";